export default "__VITE_ASSET__BH438SkM__"